// English
export const locale = {
	lang: 'en',
	data: {
		ACTION: {
			DELETE: 'delete',
			DELETE_CAPITAL: 'Delete',
			REMOVE: 'remove',
			REMOVE_CAPITAL: 'Remove',
			DEPROVISION: 'deprovision',
			DEPROVISION_CAPITAL: 'Deprovision',
			COPY: 'copy',
			COPY_CAPITAL: 'Copy',
			ENABLE: 'enable',
			ENABLE_CAPITAL: 'Enable',
			DISABLE: 'disable',
			DISABLE_CAPITAL: 'Disable',
			ACTIVATE: 'activate',
			ACTIVATE_CAPITAL: 'Activate',
			DEACTIVATE: 'deactivate',
			DEACTIVATE_CAPITAL: 'Deactivate',
			START: 'start',
			START_CAPITAL: 'Start',
			STOP: 'stop',
			STOP_CAPITAL: 'Stop',
			RESTART: 'restart',
			RESTART_CAPITAL: 'Restart',
			REFRESH: 'refresh',
			REFRESH_CAPITAL: 'Refresh',
			ADD: 'add',
			ADD_CAPITAL: 'Add',
			EDIT: 'edit',
			EDIT_CAPITAL: 'Edit',
			IMPORT: 'import',
			IMPORT_CAPITAL: 'Import',
			OVERRIDE: 'override',
			OVERRIDE_CAPITAL: 'Override',
			SAVE: 'save',
			SAVE_CAPITAL: 'Save',
			UPDATE: 'update',
			UPDATE_CAPITAL: 'Update',
		},
		ENTITY: {
			FILE: {
				TITLE: 'file',
				TITLE_CAPITAL: 'File',
				TITLE_PLURAL: 'files',
				TITLE_CAPITAL_PLURAL: 'Files',
			},
		},
		GENERIC: {
			CREATED: '{{name}} has been successfully created',
			NOT_CREATED: '{{name}} has not been created. Please, try again later or contact the administrator',
			CREATED_PLURAL: '{{name}} have been successfully created',
			NOT_CREATED_PLURAL: '{{name}} have not been created. Please, try again later or contact the administrator',

			ADDED: '{{name}} has been successfully added',
			NOT_ADDED: '{{name}} has not been added. Please, try again later or contact the administrator',
			ADDED_PLURAL: '{{name}} have been successfully added',
			NOT_ADDED_PLURAL: '{{name}} have not been added. Please, try again later or contact the administrator',

			CONFIRM_START: 'Are you sure you want to start this {{name}}?',
			STARTED: '{{name}} has been successfully started',
			NOT_STARTED: '{{name}} has not been started. Please, try again later or contact the administrator',
			STARTED_PLURAL: '{{name}} have been successfully started',
			NOT_STARTED_PLURAL: '{{name}} have not been started. Please, try again later or contact the administrator',

			RESTARTED: '{{name}} has been successfully restarted',
			NOT_RESTARTED: '{{name}} has not been restarted. Please, try again later or contact the administrator',
			RESTARTED_PLURAL: '{{name}} have been successfully restarted',
			NOT_RESTARTED_PLURAL: '{{name}} have not been restarted. Please, try again later or contact the administrator',

			REFRESHED: '{{name}} has been successfully refreshed',
			NOT_REFRESHED: '{{name}} has not been refreshed. Please, try again later or contact the administrator',
			REFRESHED_PLURAL: '{{name}} have been successfully refreshed',
			NOT_REFRESHED_PLURAL: '{{name}} have not been refreshed. Please, try again later or contact the administrator',

			ENDED: '{{name}} has been successfully ended',
			NOT_ENDED: '{{name}} has not been ended. Please, try again later or contact the administrator',
			ENDED_PLURAL: '{{name}} have been successfully ended',
			NOT_ENDED_PLURAL: '{{name}} have not been ended. Please, try again later or contact the administrator',

			ACTIVATED: '{{name}} has been successfully activated',
			NOT_ACTIVATED: '{{name}} has not been activated. Please, try again later or contact the administrator',
			ACTIVATED_PLURAL: '{{name}} have been successfully activated',
			NOT_ACTIVATED_PLURAL: '{{name}} have not been activated. Please, try again later or contact the administrator',

			CONFIRM_ENABLE: 'Are you sure you want to enable this {{name}}?',
			ENABLED: '{{name}} has been successfully enabled',
			NOT_ENABLED: '{{name}} has not been enabled. Please, try again later or contact the administrator',
			ENABLED_PLURAL: '{{name}} have been successfully enabled',
			NOT_ENABLED_PLURAL: '{{name}} have not been enabled. Please, try again later or contact the administrator',

			UPDATED: '{{name}} has been successfully updated',
			NOT_UPDATED: '{{name}} has not been updated. Please, try again later or contact the administrator',
			UPDATED_PLURAL: '{{name}} have been successfully updated',
			NOT_UPDATED_PLURAL: '{{name}} have not been updated. Please, try again later or contact the administrator',

			COPIED: '{{name}} has been successfully copied',
			NOT_COPIED: '{{name}} has not been copied. Please, try again later or contact the administrator',
			COPIED_PLURAL: '{{name}} have been successfully copied',
			NOT_COPIED_PLURAL: '{{name}} have not been copied. Please, try again later or contact the administrator',

			DOWNLOADED: '{{name}} has been successfully downloaded',
			NOT_DOWNLOADED: '{{name}} has not been downloaded. Please, try again later or contact the administrator',
			DOWNLOADED_PLURAL: '{{name}} have been successfully downloaded',
			NOT_DOWNLOADED_PLURAL: '{{name}} have not been downloaded. Please, try again later or contact the administrator',

			CONFIRM_STOP: 'Are you sure you want to stop this {{name}}?',
			STOPPED: '{{name}} has been successfully stopped',
			NOT_STOPPED: '{{name}} has not been stopped. Please, try again later or contact the administrator',
			STOPPED_PLURAL: '{{name}} have been successfully stopped',
			NOT_STOPPED_PLURAL: '{{name}} have not been stopped. Please, try again later or contact the administrator',

			CONFIRM_DELETE: 'Are you sure you want to delete this {{name}}?',
			DELETED: '{{name}} has been successfully deleted',
			NOT_DELETED: '{{name}} has not been deleted. Please, try again later or contact the administrator',
			DELETED_PLURAL: '{{name}} have been successfully deleted',
			NOT_DELETED_PLURAL: '{{name}} have not been deleted. Please, try again later or contact the administrator',

			CONFIRM_DELETE_ALL: 'Are you sure you want to delete all {{name}}?',
			CONFIRM_CLEAR_ALL: 'Are you sure you want to clear all {{name}}?',

			CONFIRM_REMOVE: 'Are you sure you want to remove this {{name}}?',
			CONFIRM_REMOVE_FROM: 'Are you sure you want to remove this {{name}} from this {{from}}?',

			REMOVED: '{{name}} has been successfully removed',
			NOT_REMOVED: '{{name}} has not been removed. Please, try again later or contact the administrator',
			REMOVED_PLURAL: '{{name}} have been successfully removed',
			NOT_REMOVED_PLURAL: '{{name}} have not been removed. Please, try again later or contact the administrator',

			CONFIRM_REMOVE_ALL: 'Are you sure you want to remove all {{name}}?',

			CONFIRM_DEACTIVATE: 'Are you sure you want to deactivate this {{name}}?',
			DEACTIVATED: '{{name}} has been successfully deactivated',
			NOT_DEACTIVATED: '{{name}} has not been deactivated. Please, try again later or contact the administrator',
			DEACTIVATED_PLURAL: '{{name}} have been successfully deactivated',
			NOT_DEACTIVATED_PLURAL: '{{name}} have not been deactivated. Please, try again later or contact the administrator',

			CONFIRM_DISABLE: 'Are you sure you want to disable this {{name}}?',
			DISABLED: '{{name}} has been successfully disabled',
			NOT_DISABLED: '{{name}} has not been disabled. Please, try again later or contact the administrator',
			DISABLED_PLURAL: '{{name}} have been successfully disabled',
			NOT_DISABLED_PLURAL: '{{name}} have not been disabled. Please, try again later or contact the administrator',

			CONFIRM_DEPROVISION: 'Are you sure you want to deprovision this {{name}}?',
			DEPROVISIONED: '{{name}} has been successfully deprovisioned',
			NOT_DEPROVISIONED: '{{name}} has not been deprovisioned. Please, try again later or contact the administrator',
			DEPROVISIONED_PLURAL: '{{name}} have been successfully deprovisioned',
			NOT_DEPROVISIONED_PLURAL: '{{name}} have not been deprovisioned. Please, try again later or contact the administrator',

			NOT_FOUND: '{{name}} was not found. Please try again later, or contact the administrator',
			NOT_FOUND_PLURAL: '{{name}} were not found. Please try again later, or contact the administrator',

			ERROR_GETTING: 'There was an error getting {{name}}. Please, try again later or contact the administrator',

			SEQUENCE_UPDATED: '{{name}} sequence has been successfully updated',
			SEQUENCE_NOT_UPDATED: '{{name}} sequence has not been updated. Please, try again later or contact the administrator',

			NO_LONGER_EXISTS: '{{name}} no longer exists',

			IMPORTED: '{{name}} has been successfully imported',
			NOT_IMPORTED: '{{name}} has not been imported. Please, try again later or contact the administrator',

			CONFIRM: 'Are you sure you want to do this?',
			HAS_SYNCED: 'Sync has been successfully completed',
			SYNC_FAILED: 'Sync has failed. Please, try again later or contact the administrator',
			SYNC_SUCCESSFULL_COMMON_FAILED: 'Sync has been successfull completed. However, common sync has failed. Please, try again later or contact the administrator',
			SYNC_SUCCESSFULL_JOB_FAILED: 'Sync has been successfull completed. However, job sync has failed. Please, try again later or contact the administrator',
			COMPLETED: 'has been successfully completed',
			SYNC_FAILED_PORTAL_UNREACHABLE: 'Sync failed - the portal is unreachable',
			SYNC_FAILED_TO_RETRIEVE_DATA: 'Sync failed - failed to retrieve data from portal',
			SYNC_FAILED_TO_SEND_DATA: 'Sync failed - failed to send data to portal',
			SYNC_FAILED_TEMPORARY_UNIT: 'Sync failed - Temporary unit in use',
			CONFIRM_SYNC: 'Are you sure you want to start sync process?',
			UNKNOWN_ERROR: 'An unknown error has occured. Please try again later, or contact the administrator',
			IS_STREAMING_DATA: 'is streaming data',
			WARNING_DATA_LOSS: 'by doing this, you might lose data',
			ACTION_SUCCEEDED: 'The action was successfully completed',
			ACTION_FAILED: 'The action failed. Please try again later, or contact the administrator',

			VALIDATION: {
				FIELD_REQUIRED: 'Field is required',
				FIELD_INVALID: 'Field is invalid',
				FIELD_MIN_LENGTH: 'Minimum length is',
				FIELD_MAX_LENGTH: 'Maximum length is',
				FIELD_MIN_LENGTH_NOT_MET: 'Minimum length is not met',
				FIELD_MAX_LENGTH_EXCEEDED: 'Maximum length is exceeded',
			},
		},
		MODULE: {
			ATTACHMENT: {
				TITLE: 'attachment',
				TITLE_CAPITAL: 'Attachment',
				TITLE_PLURAL: 'attachments',
				TITLE_CAPITAL_PLURAL: 'Attachments',
			},
			AUTH: {
				GENERAL: {
					OR: 'Or',
					SUBMIT_BUTTON: 'Submit',
					NO_ACCOUNT: "Don't have an account?",
					SIGNUP_BUTTON: 'Sign up',
					FORGOT_BUTTON: 'Forgot password',
					BACK_BUTTON: 'Back',
					PRIVACY: 'Privacy',
					LEGAL: 'Legal',
					CONTACT: 'Contact',
				},
				LOGIN: {
					TITLE: 'Sign in',
					BUTTON: 'Login',
				},
				FORGOT: {
					TITLE: 'Forgotten password?',
					DESC: 'Enter your email to reset your password',
					SUCCESS: 'An email has been sent to reset your password.',
				},
				CHANGE: {
					TITLE: 'Change Password',
					DESC: 'Please Change Your Password',
					SUCCESS: 'Your password has been changed.',
				},
				REGISTER: {
					TITLE: 'Sign up',
					DESC: 'Enter your details to create your account',
					SUCCESS: 'Your account has been successfuly registered and pending company approval.',
					BUTTON: 'Register',
				},
				INPUT: {
					EMAIL: 'Email',
					FULLNAME: 'Fullname',
					PASSWORD: 'Password',
					CONFIRM_PASSWORD: 'Confirm Password',
					USERNAME: 'Username or Email',
				},
				VALIDATION: {
					INVALID: '{{name}} is not valid',
					REQUIRED: '{{name}} is required',
					MIN_LENGTH: '{{name}} minimum length is {{min}}',
					AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
					NOT_FOUND: 'The requested {{name}} is not found',
					INVALID_LOGIN: 'The login credentials provided are invalid',
					REQUIRED_FIELD: 'Field is required',
					MIN_LENGTH_FIELD: 'Minimum field length:',
					MAX_LENGTH_FIELD: 'Maximum field length:',
					INVALID_FIELD: 'Field is not valid',
				},
			},
			BOP: {
				TITLE: 'BOP',
				TITLE_CAPITAL: 'BOP',
				TITLE_PLURAL: 'BOPs',
				NOT_UPDATED_ONLY_PROD: 'BOP has not been updated. This can only be done in production. Please, try again later or contact the administrator',
			},
			BOP_FORM: {
				TITLE: 'BOP form',
				TITLE_CAPITAL: 'BOP form',
				TITLE_PLURAL: 'BOP forms',
			},
			CHANNEL: {
				TITLE: 'channel',
				TITLE_CAPITAL: 'Channel',
				TITLE_PLURAL: 'channels',
			},
			COMMENT: {
				TITLE: 'comment',
				TITLE_CAPITAL: 'Comment',
				TITLE_PLURAL: 'comments',
				DEFAULT_GROUP: {
					TITLE: 'comment default group',
					TITLE_CAPITAL: 'Comment default group',
					TITLE_PLURAL: 'comment default groups',
				},
				DEFAULT: {
					TITLE: 'comment default',
					TITLE_CAPITAL: 'Comment default',
					TITLE_PLURAL: 'comment default',
				},
				LINK: {
					TITLE: 'comment default link',
					TITLE_CAPITAL: 'Comment default link',
					TITLE_PLURAL: 'comment default links',
				},
			},
			COMPANY: {
				TITLE: 'company',
				TITLE_CAPITAL: 'Company',
				TITLE_PLURAL: 'companies',
				SINGLE_ADDED_TO_USER: 'Company has been successfully added to user',
				MULTIPLE_ADDED_TO_USER: 'Companies have been successfully added to user',
				REMOVED_FROM_USER: 'Company has been successfully removed from user',
				COMPANY_NAME_INVALID_ERROR: 'Company name already in use. Please specify another',
			},
			CONFIG: {
				TITLE: 'configuration',
				TITLE_CAPITAL: 'Configuration',
				TITLE_PLURAL: 'configurations',
			},
			CONNECTION_STATUS: {},
			DAILY_REPORT: {
				TITLE: 'daily report',
				TITLE_CAPITAL: 'Daily report',
				TITLE_PLURAL: 'daily reports',
			},
			DASHBOARD: {
				TITLE: 'dashboard',
				TITLE_CAPITAL: 'Dashboard',
				TITLE_PLURAL: 'dashboards',
				CANT_SAVE_EMPTY: 'Saving empty dashboard is not allowed. Please, add widgets to the dashboard before saving',
			},
			DEVICE: {
				TITLE: 'device',
				TITLE_CAPITAL: 'Device',
				TITLE_PLURAL: 'devices',
			},
			DEVICE_UNIT: {
				TITLE: 'device unit',
				TITLE_CAPITAL: 'Device unit',
				TITLE_PLURAL: 'device units',
			},
			DISTRICT: {
				TITLE: 'district',
				TITLE_CAPITAL: 'District',
				TITLE_PLURAL: 'districts',
				SINGLE_ADDED_TO_USER: 'District has been successfully added to user',
				MULTIPLE_ADDED_TO_USER: 'Districts have been successfully added to user',
				REMOVED_FROM_USER: 'District has been successfully removed from user',
			},
			ERROR: {
				NOT_FOUND: {
					CODE: 404,
					TITLE: 'page not found',
					DESCRIPTION: 'The page you’re looking for either doesn’t exist or might have been moved. Please, try again later or contact the administrator',
				},
				FORBIDDEN: {
					CODE: 403,
					TITLE: 'access forbidden',
					DESCRIPTION: 'It seems you don’t have the necessary permissions to access this page. Please, try again later or contact the administrator',
				},
				BAD_REQUEST: {
					CODE: 400,
					TITLE: 'bad request',
					DESCRIPTION: 'It looks like the server couldn’t understand your request. This might be due to a typo, incorrect URL, or an invalid input. Please, try again later or contact the administrator',
				},
			},
			JDR: {
				TITLE: 'JDR',
				EMAILED: 'JDR has been successfully emailed',
				NOT_EMAILED: 'JDR has not been emailed. Please, try again later or contact the administrator',
			},
			JOB: {
				TITLE: 'job',
				TITLE_CAPITAL: 'Job',
				TITLE_PLURAL: 'jobs',

				NOT_READY: 'Job is not ready yet. Please, try again later or contact the administrator',
				ADDED_TO_COMPANY: 'Job has been successfully added to company',
				REMOVED_FROM_COMPANY: 'Job has been successfully removed from company',
				ALERTS_UPDATED: 'Job alerts have been successfully updated',
				LINK_CREATED_COPIED: 'Job link has been successfully created and copied to clipboard',
				LINK_NOT_CREATED: 'There was an error creating job link. Please, try again later or contact the administrator',
				LINK_COPIED: 'Job link has been successfully copied to clipboard',
				LINK_ACTIVATED: 'Job links have been successfully activated',
				LINK_DEACTIVATED: 'Job links have been successfully deactivated',
				NO_LONGER_EXISTS: 'Job no longer exists',
				IS_BEING_DELETED: 'Job is currently being deleted. Please, be patient',
				COMPLETED_JOB_SEARCH_ERROR: 'There was an error performing this completed jobs search. Please try again.',

				ACTIVE_JOB: {
					TITLE: 'active job',
					TITLE_CAPITAL: 'Active job',
					TITLE_PLURAL: 'active jobs',
				},
				CUSTOM_CHART: {
					MIN_OR_MAX_DATE_INVALID: 'Either min or max date is invalid. Please, try again later or contact the administrator',
				},
				LINK: {
					TITLE: 'job link',
					TITLE_CAPITAL: 'Job link',
					TITLE_PLURAL: 'job links',
				},
				LINK_EXPIRED: 'Link successfully expired',
			},
			JOB_DATA: {
				DATA: {
					NOT_DOWNLOADED: 'Data was not downloaded. Please try again later, or contact the administrator',
				},

				FATIGUE_DATA: {
					NOT_DOWNLOADED: 'Fatigue data was not downloaded. Please try again later, or contact the administrator',
					DEPTH: {
						NOT_FOUND: 'Depth channel was not found. Fatigue data was not downloaded. Please try again later, or contact the administrator',
					},
				},
			},
			LOOKUP: {
				TITLE: 'lookup',
				TITLE_CAPITAL: 'Lookup',
				TITLE_PLURAL: 'lookups',
				ERROR_GETTING: 'There was an error getting lookups. Please, try again later or contact the administrator',
			},
			NOTIFICATION: {
				TITLE: 'notification',
				TITLE_CAPITAL: 'Notification',
				TITLE_PLURAL: 'notifications',
			},
			OUTPUT_CONFIG: {
				TITLE: 'output configuration',
				TITLE_CAPITAL: 'Output configuration',
				TITLE_PLURAL: 'output configurations',

				STARTED: 'Output configuration has been successfully started',
				NOT_STARTED: 'Output configuration has not been started. Please, try again later or contact the administrator',

				CONFIRM_ENABLE: 'Are you sure you want to enable the output configuration?',

				CONFIRM_DISABLE: 'Are you sure you want to disable the output configuration?',

				CONFIRM_RESTART: 'Are you sure you want to restart the output configuration?',

				STOPPED: 'Output configuration has been successfully stopped',
				NOT_STOPPED: 'Output configuration has not been stopped. Please, try again later or contact the administrator',
			},
			PERIPHERAL_UNIT: {
				TITLE: 'peripheral unit',
				TITLE_CAPITAL: 'Peripheral unit',
				TITLE_PLURAL: 'peripheral unit',
			},
			REEL: {
				TITLE: 'reel',
				TITLE_CAPITAL: 'Reel',
				TITLE_PLURAL: 'reels',
			},
			SPLIT_MERGE: {
				SPLIT_STARTED: 'Split / Merge is preparing to split data to a new job',
				MERGE_STARTED: 'Split / Merge is preparing to merge data to the target job',
				SUCCEEDED: 'Split / Merge succeeded',
				FAILED: 'Split / Merge failed',
			},
			STRING: {
				TITLE: 'string',
				TITLE_CAPITAL: 'String',
				TITLE_PLURAL: 'strings',
			},
			TEMPORARY_UNIT: {
				TITLE: 'temporary unit',
				TITLE_CAPITAL: 'Temporary unit',
				TITLE_PLURAL: 'temporary units',
				SELECT: 'Please, select temporary unit',
			},
			THEME: {
				TITLE: 'theme',
				TITLE_CAPITAL: 'Theme',
			},
			UNIT: {
				TITLE: 'unit',
				TITLE_CAPITAL: 'Unit',
				TITLE_PLURAL: 'units',
				TITLE_CAPITAL_PLURAL: 'Units',
				REMOVED_FROM_USER: 'Unit has been successfully removed from user',
				CONFIRM_RESTART: 'Are you sure you want to restart the unit?',
				TEMPORARY_MATCHED: 'Temporary unit has been successfully matched',
				SINGLE_ADDED_TO_USER: 'Unit has been successfully added to user',
				MULTIPLE_ADDED_TO_USER: 'Units have been successfully added to user',
				SINGLE_ADDED_TO_DISTRICT: 'Unit has been successfully added to district',
				MULTIPLE_ADDED_TO_DISTRICT: 'Units have been successfully added to district',
				UNIT_DATA_MOVED: 'Unit data has been successfully moved to different job',
				ALREADY_ACTIVE: 'Unit is already active',
			},
			UNIT_CONFIG: {
				TITLE: 'unit configuration',
				TITLE_CAPITAL: 'Unit configuration',
				TITLE_PLURAL: 'unit configurations',
				IMPORTED: 'Unit configuration has been successfully imported',
				NOT_IMPORTED: 'Unit configuration has not been imported. Please, try again later or contact the administrator',
			},
			USER: {
				TITLE: 'user',
				TITLE_CAPITAL: 'User',
				TITLE_PLURAL: 'users',
				NOT_AUTHORIZED_TO_DELETE: 'You are not authorized to delete this user. Please contact the administrator',
				NOT_AUTHORIZED_TO_CHANGE_PASSWORD: 'You are not authorized to change password for this user. Please contact the administrator',
				CONFIRM_DELETE: 'Are you sure you want to delete this user?',

				INVITED: 'User has been successfully invited',
				NOT_ACTIVE: 'User you selected is not active',
				ADDED_TO_UNIT: 'User has been successfully added to unit',
				REMOVED_FROM_UNIT: 'User has been successfully removed from unit',
				REMOVED_FROM_COMPANY: 'User has been successfully removed from company',
				REMOVED_FROM_DISTRICT: 'User has been successfully removed from district',
				INFO_UPDATED: 'User information has been updated',
				PASSWORD_CHANGED: 'Password has been successfully changed for user',
				SINGLE_ADDED_TO_DISTRICT: 'User has been successfully added to district',
				MULTIPLE_ADDED_TO_DISTRICT: 'User have been successfully added to district',
			},
			WIDGET: {
				TITLE: 'widget',
				TITLE_CAPITAL: 'Widget',
				TITLE_PLURAL: 'widgets',
			},
		},
	},
};
